/* ═══════════════════════════════════════════════════════════════
   BB ARTICLE — JavaScript
   Reading progress bar, copy link toast, smooth interactions
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── Reading Progress Bar ── */
  const progressFill = document.getElementById('bba-progress-fill');
  const progressBar  = document.getElementById('bba-progress');
  const content      = document.getElementById('bba-body');

  function updateProgress() {
    if (!progressFill || !content) return;
    const contentTop    = content.getBoundingClientRect().top + window.scrollY;
    const contentBottom = contentTop + content.offsetHeight;
    const scrolled      = window.scrollY + window.innerHeight;
    const total         = contentBottom - contentTop;
    const progress      = Math.min(Math.max((window.scrollY - contentTop + window.innerHeight * 0.5) / total, 0), 1);
    const pct           = Math.round(progress * 100);
    progressFill.style.width = pct + '%';
    if (progressBar) progressBar.setAttribute('aria-valuenow', pct);
  }

  window.addEventListener('scroll', updateProgress, { passive: true });
  updateProgress();

  /* ── Copy Link Toast ── */
  function createToast() {
    const t = document.createElement('div');
    t.className = 'bba__copy-toast';
    t.textContent = 'Link copied';
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    document.body.appendChild(t);
    return t;
  }

  let toast = null;
  let toastTimer = null;

  function showToast() {
    if (!toast) toast = createToast();
    clearTimeout(toastTimer);
    toast.classList.add('bba__copy-toast--show');
    toastTimer = setTimeout(function () {
      toast.classList.remove('bba__copy-toast--show');
    }, 2200);
  }

  document.querySelectorAll('.bba__copy-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const url = btn.dataset.url || window.location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(showToast).catch(function () {
          fallbackCopy(url);
        });
      } else {
        fallbackCopy(url);
      }
    });
  });

  function fallbackCopy(text) {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try { document.execCommand('copy'); showToast(); } catch (e) {}
    document.body.removeChild(ta);
  }

  /* ── Lazy image fade-in ── */
  if ('IntersectionObserver' in window) {
    const imgObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          imgObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px 100px 0px' });

    document.querySelectorAll('.bba__related-img').forEach(function (img) {
      img.style.opacity = '0';
      img.style.transition = 'opacity 0.4s ease';
      imgObserver.observe(img);
    });
  }

  /* ── External links in article body open in new tab ── */
  document.querySelectorAll('.bba__body a[href]').forEach(function (link) {
    try {
      const url = new URL(link.href, window.location.href);
      if (url.hostname !== window.location.hostname) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    } catch (e) {}
  });

})();
